var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import i18next from '../../../strings/i18n/i18n';
import { IMAGE_ASSET_PATHS } from '../../../const/alertsConfig';
import { InfoBodyWrapper, InfoContentWrapper, InfoImageWrapper, InfoImg, InfoTitleWrapper, MarketingPrivacyErrorWrapper } from './subcomponents';
var MarketingPrivacyInfoNotAvailable = function (_a) {
    var _b;
    var mfeConfig = _a.mfeConfig;
    var title = "".concat(i18next.t('marketingPrivacySettingsError.title'));
    var message = "".concat(i18next.t('marketingPrivacySettingsError.infoNotAvailable'));
    var ASSET_HOST = (_b = mfeConfig === null || mfeConfig === void 0 ? void 0 : mfeConfig.hosts) === null || _b === void 0 ? void 0 : _b.assets;
    return (_jsxs(MarketingPrivacyErrorWrapper, __assign({ "data-test": "MarketingPrivacyErrorWrapper" }, { children: [_jsx(InfoImageWrapper, __assign({ "data-test": "InfoImageWrapper" }, { children: _jsx(InfoImg, { src: "".concat(ASSET_HOST).concat(IMAGE_ASSET_PATHS.MARKETING_PRIVACY_ERROR_IMAGE), alt: "Info not available" }) })), _jsxs(InfoContentWrapper, __assign({ "data-test": "InfoContentWrapper" }, { children: [_jsx(InfoTitleWrapper, __assign({ id: "InfoTitle", "data-test": "InfoTitleWrapper" }, { children: title })), _jsx(InfoBodyWrapper, __assign({ id: "infoBody", "data-test": "InfoBodyWrapper" }, { children: message }))] }))] })));
};
export default MarketingPrivacyInfoNotAvailable;
